import { NavLink, useLocation } from 'react-router-dom';

const TABS = [
  { label: '首页', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', path: '/' },
  { label: '分类', icon: 'ri-layout-grid-line', activeIcon: 'ri-layout-grid-fill', path: '/category/movie', match: '/category' },
  { label: '搜索', icon: 'ri-search-line', activeIcon: 'ri-search-eye-line', path: '/search' },
  { label: '专题', icon: 'ri-bookmark-line', activeIcon: 'ri-bookmark-fill', path: '/special/special-01', match: '/special' },
  { label: '我的', icon: 'ri-user-line', activeIcon: 'ri-user-fill', path: '/about' },
];

export default function MobileTabBar() {
  const location = useLocation();

  const isActive = (tab: (typeof TABS)[number]) => {
    if (tab.path === '/') return location.pathname === '/';
    if (tab.match) return location.pathname.startsWith(tab.match);
    return location.pathname.startsWith(tab.path);
  };

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-background-200 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden"
      aria-label="移动端底部导航"
    >
      <div className="flex h-16 items-stretch">
        {TABS.map((tab) => {
          const active = isActive(tab);
          return (
            <NavLink
              key={tab.label}
              to={tab.path}
              className="flex flex-1 cursor-pointer flex-col items-center justify-center gap-1"
            >
              <span className={`flex h-6 w-6 items-center justify-center ${active ? 'text-accent-500' : 'text-foreground-400'}`}>
                <i className={`${active ? tab.activeIcon : tab.icon} text-xl`} />
              </span>
              <span className={`text-[11px] ${active ? 'font-medium text-foreground-950' : 'text-foreground-400'}`}>
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}